import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineClose } from 'react-icons/md';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import { FaXTwitter } from "react-icons/fa6";
import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <nav className='app__navbar' id='navbar'>
      <div className='app__navbar-logo'>
        <img src={images.navlogo} alt='app logo'/>
      </div>
      <ul className='app__navbar-links'>
          <li className='p__opensans'><a href='#home' style={{ fontSize: '22px',  color: 'var(--color-black)' }}><strong>Inicio</strong></a></li>
          <li className='p__opensans'><a href='#menu' style={{ fontSize: '22px', color: 'var(--color-black)' }}><strong>Menú</strong></a></li>
          <li className='p__opensans'><a href='#footer' style={{ fontSize: '22px', color: 'var(--color-black)' }}><strong>Contacto</strong></a></li>
      </ul>
      <div className='app__navbar-login'>
        <a href='#footer' className='p__opensans' style={{ fontSize: '22px', color: 'var(--color-black)' }}><strong>Delivery</strong></a>
        <div />
        <a href="#gallery" className='p__opensans' style={{ fontSize: '22px', color: 'var(--color-black)' }}><strong>Agendar Reserva</strong></a>
    </div>
    <div className='app__navbar-smallscreen'>
      <GiHamburgerMenu color='#fff' fontSize={27} onClick={() => setToggleMenu(true)}/>
      
      {toggleMenu && (
        <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
          <MdOutlineClose fontSize={27} className='overlay__close' onClick={() => setToggleMenu(false)}/>
          <ul className='app__navbar-smallscreen-links'>
          <li className='p__opensans'><a href='#navbar' style={{ fontSize: '22px'}} onClick={() => setToggleMenu(false)}><strong>Inicio</strong></a></li>
          <li className='p__opensans'><a href='#menu' style={{ fontSize: '22px'}} onClick={() => setToggleMenu(false)}><strong>Menú</strong></a></li>
          <li className='p__opensans'><a href='#footer' style={{ fontSize: '22px'}} onClick={() => setToggleMenu(false)}><strong>Delivery</strong></a></li>
          <li className='p__opensans'><a href='#footer' style={{ fontSize: '22px'}} onClick={() => setToggleMenu(false)}><strong>Agendar reserva</strong></a></li>
          </ul>
          <div className='app__navbar-links_icons'>
            <FiFacebook id='singular-icon' style={{ color: '#FF7CB7' }}/>
            <FaXTwitter id='singular-icon' style={{ color: '#FF7CB7' }}/>
            <FiInstagram id='singular-icon' style={{ color: '#FF7CB7' }}/>
          </div>
        </div>
      )}
    </div>
    </nav>
  )
}

export default Navbar;
